import { default as dummyDefault } from './dummy/index';
import { default as dummyUnder18 } from './dummy/under18';

export const dummy = {
  default: dummyDefault,
  under18: dummyUnder18,
};
